import { render, staticRenderFns } from "./mapaLeafletClusters.vue?vue&type=template&id=0023b5c0&lang=pug"
import script from "./mapaLeafletClusters.vue?vue&type=script&lang=js"
export * from "./mapaLeafletClusters.vue?vue&type=script&lang=js"
import style0 from "./mapaLeafletClusters.vue?vue&type=style&index=0&id=0023b5c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports